import { BarsGraphData } from 'modules/project_management/components/charts/EvolutionChart/getEvolutionTransformedData'

export const mockBarsData: BarsGraphData[] = [
  {
    title: '18',
    value: 100,
    color: 'hsl(248, 70%, 50%)',
  },
  {
    title: '19',
    value: 140,
    color: 'hsl(234, 70%, 50%)',
  },
  {
    title: '20',
    value: 160,
    color: 'hsl(64, 70%, 50%)',
  },
  {
    title: '21',
    value: 160,
    color: 'hsl(6, 70%, 50%)',
  },
  {
    title: '22',
    value: 250,
    color: 'hsl(22, 70%, 50%)',
  },
  {
    title: '23',
    value: 320,
    color: 'hsl(124, 70%, 50%)',
  },
  {
    title: '24',
    value: 400,
    color: 'hsl(126, 70%, 50%)',
  },
]
